import cookies from 'js-cookie';
import api from '../marketing/api';

const authChatBotCookieName = 'AuthChatConnection';
export default function () {
  let timer;

  function logout() {
    window.location.href = "/account/time-out";
  }

  function checkLogout() {
    const baseDomain = location.hostname.split(".").slice(-2).join(".");
    if (cookies.get(authChatBotCookieName, { domain: baseDomain }) && cookies.get(authChatBotCookieName, { domain: baseDomain }) === 'true') {
      try {
        window.isConnect().then((isConnected) => {
          if (isConnected) {
            api.get('/extendtimeout', {}, false)
              .then(() => {
                clearTimeout(timer);
                timer = setTimeout(checkLogout, 120000);
              })
              .catch(() => {
                logout();
              });
          } else {
            logout();
          }
        });
      } catch (e) {
        logout();
      }
    } else {
      logout();
    }
  }

  function reset() {
    clearTimeout(timer);
    timer = setTimeout(checkLogout, 1740000);
    // 1,740,000ms = 29min
  }

  // check cookies to see if user is logged in
  function checkIfUserIsLoggedIn() {
    const cookieName = 'isAuthenticated';
    const cookie = cookies.get(cookieName);

    if (cookie && cookie !== 'false') {
      // if user is logged in, start timer
      // and stop checking that they're logged in
      reset();
      clearInterval(checkLoginAgain); // eslint-disable-line no-use-before-define
    }
  }

  // periodically check if the user is logged in
  const checkLoginAgain = setInterval(() => {
    checkIfUserIsLoggedIn();
  }, 3000);
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/inactiveUserLogout.js